/*--------------------------------------------------------------
# Video lightbox
# Shared by the Knowledge Bank feed blocks: any card carrying
# [data-video-open="N"] opens panel N of the [data-video-lightbox]
# that lives inside the same [data-video-lightbox-root].
--------------------------------------------------------------*/

(function () {
	function initLightbox(root) {
		var lightbox = root.querySelector('[data-video-lightbox]');

		if (!lightbox) {
			return;
		}

		// A feed that clips its own overflow (so a bleeding carousel can't scroll the
		// page sideways) would clip a fixed overlay inside it too. Moving the lightbox
		// to the body puts it out of reach of that, and of any stacking context an
		// ancestor might create.
		document.body.appendChild(lightbox);

		var panels = Array.prototype.slice.call(lightbox.querySelectorAll('[data-video-panel]'));
		var closeButton = lightbox.querySelector('.video-lightbox__close');
		var lastTrigger = null;

		// The players are built by the theme's own scripts (youtube.js for YouTube, the
		// video component for Vimeo), which keep their player instances to themselves -
		// so stopping playback goes through each iframe's postMessage API instead.
		// Sending both dialects is harmless: each player ignores the one it doesn't know.
		function stopPanel(panel) {
			var wrap = panel.querySelector('.video-wrap');
			var iframe = panel.querySelector('iframe');

			if (iframe && iframe.contentWindow) {
				iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
				iframe.contentWindow.postMessage('{"method":"pause"}', '*');
			}

			// Bring the poster and play button back for the next time it's opened.
			if (wrap) {
				wrap.classList.remove('interacted');
			}
			var vimeoButton = panel.querySelector('.vimeo-button');
			if (vimeoButton) {
				vimeoButton.style.display = '';
			}
		}

		function close() {
			panels.forEach(function (panel) {
				stopPanel(panel);
				panel.hidden = true;
			});
			lightbox.hidden = true;
			document.body.style.overflow = '';

			if (lastTrigger) {
				lastTrigger.focus();
				lastTrigger = null;
			}
		}

		function open(index, trigger) {
			panels.forEach(function (panel) {
				panel.hidden = panel.getAttribute('data-video-panel') !== String(index);
			});
			lightbox.hidden = false;
			document.body.style.overflow = 'hidden';
			lastTrigger = trigger;

			if (closeButton) {
				closeButton.focus();
			}
		}

		Array.prototype.slice.call(root.querySelectorAll('[data-video-open]')).forEach(function (card) {
			card.addEventListener('click', function () {
				open(card.getAttribute('data-video-open'), card);
			});
		});

		// Both the X and the blurred background close the overlay.
		Array.prototype.slice.call(lightbox.querySelectorAll('[data-video-close]')).forEach(function (el) {
			el.addEventListener('click', close);
		});

		document.addEventListener('keydown', function (event) {
			if ('Escape' === event.key && !lightbox.hidden) {
				close();
			}
		});
	}

	function init() {
		Array.prototype.slice.call(document.querySelectorAll('[data-video-lightbox-root]')).forEach(initLightbox);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
